import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  setExchEvent,
  setEventType,
  setCompetition,
  fetchCompetitions,
  fetchEventsByCompetition,
  addToMultiMarket,
  removeToMultiMarket,
  checkIncludeMultiMarket,
} from '../../store';
import { SelectedObj } from '../../models/ExchangeSportsState';
import LiveTvIcon from '@material-ui/icons/LiveTv';
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Tooltip,
  TextField,
} from '@material-ui/core';
import './ExchEventsTable.scss';
import { IonCol, IonImg, IonRow } from '@ionic/react';
import { ReactComponent as Inplay } from '../../assets/images/icons/inplay-mob.svg';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { RootState } from '../../models/RootState';
import ExchOddBtn from '../ExchOddButton/ExchOddButton';
import { ReactComponent as Cricket } from '../../assets/images/sidebar/cricket.svg';
import { ReactComponent as Football } from '../../assets/images/sidebar/Soccer.svg';
import { ReactComponent as Tennis } from '../../assets/images/sidebar/tennis.svg';
import { ReactComponent as casino } from '../../assets/images/icons/casino.svg';
import { ReactComponent as Horseracing } from '../../assets/images/sidebar/Horse.svg';
import { ReactComponent as Baseball } from '../../assets/images/sidebar/baseball.svg';
import { ReactComponent as GreyHound } from '../../assets/images/sidebar/Greyhound.svg';

import { ReactComponent as Basketball } from '../../assets/images/sidebar/basketball.svg';

// import ExchBetslip from '../ExchBetslip/ExchBetslip';
import {
  formatDate,
  liveImagesMap,
  SportIconMap,
  SportIconMapInplay,
} from '../../util/stringUtil';
import ExchMobOddView from '../ExchOddButton/ExchMobOddView';
import {
  subscribeWsForEventOdds,
  // unsubscribeAllWsforEvents,
  disconnectToWS,
} from '../../webSocket/webSocket';
import { EventDTO } from '../../models/common/EventDTO';
import HomeView from '../../constants/HomeView';
import { useMarketLocalState } from '../../hooks/storageHook';
import multipin from '../../assets/images/common/multipin.svg';
import removemultipin from '../../assets/images/common/removemultimarket.svg';
import moment from 'moment';
import { Autocomplete } from '@material-ui/lab';
import { toast } from 'react-toastify';
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import { ReactComponent as SearchIcon } from '../../assets/images/common/searchIcon.svg';
import { Carousel } from 'react-responsive-carousel';
import CasinoView from '../../constants/CasinoView';
import { AuthResponse } from '../../models/api/AuthResponse';
import SVLS_API from '../../svls-api';
import { BRAND_DOMAIN } from '../../constants/Branding';
import { sideHeaderTabs } from '../SideHeader/SideHeaderUtil';
import { getSportLangKeyByName } from '../../util/localizationUtil';

type InplayEventsObj = {
  sportId: string;
  sportName: string;
  sportSlug: string;
  events: EventDTO[];
};

type StoreProps = {
  allowedConfig: number;
  inplayEvents: InplayEventsObj[];
  setEventType: (event: SelectedObj) => void;
  setCompetition: (event: SelectedObj) => void;
  setExchEvent: (event: SelectedObj) => void;
  fetchCompetitions: (eventTypeId: string) => void;
  fetchEventsByCompetition: (
    eventTypeId: string,
    competitionId: string
  ) => string;
  // addExchangeBet: (data: BsData) => void;
  // bets: BsData[];
  fetchingEvents: boolean;
  loggedIn: boolean;
  topicUrls: any;
  betFairWSConnected: boolean;
  langData:any;
};

export const teamTypes = ['home', 'draw', 'away'];
export const arr = [1, 'X', 2];

export const getOdds = (eventData: EventDTO, teamType: string) => {
  const team =
    teamType === 'home'
      ? eventData.homeTeam
      : teamType === 'away'
      ? eventData.awayTeam
      : teamType;

  for (let runner of eventData.matchOdds.runners) {
    if (
      runner.runnerName.toLowerCase() === team.toLowerCase() ||
      runner.runnerName.toLowerCase().includes(team.toLowerCase())
    ) {
      return [
        {
          type: 'back-odd',
          price: runner?.backPrices[0]?.price,
          size: runner.backPrices[0]?.size,
          outcomeId: runner?.runnerId,
          outcomeName: runner.runnerName,
        },
        {
          type: 'lay-odd',
          price: runner?.layPrices[0]?.price,
          size: runner?.layPrices[0]?.size,
          outcomeId: runner.runnerId,
          outcomeName: runner.runnerName,
        },
      ];
    }
  }
  return null;
};

const InplayEventsTable: React.FC<StoreProps> = (props) => {
  const {
    allowedConfig,
    inplayEvents,
    setEventType,
    setCompetition,
    setExchEvent,
    fetchCompetitions,
    fetchEventsByCompetition,
    // addExchangeBet,
    // bets,
    fetchingEvents,
    loggedIn,
    topicUrls,
    betFairWSConnected,
    langData
  } = props;
  const history = useHistory();
  const [multiMarketData, setMultiMarketData] = useMarketLocalState();
  const teamTypes = ['home', 'draw', 'away'];
  // const [openBetslip, setOpenBetslip] = useState<boolean>(true);
  const [wsChannels, setWsChannels] = useState<string[]>([]);
  const [eventsData, setEventsData] = useState([]);
  const [eventName, setEventName] = useState<string>('');
  const [apiWebBanners, setApiWebBanners] = useState([]);
  const [apiMobBanners, setApiMobBanners] = useState([]);
  const [matchOddsBaseUrl, setMatchOddsBaseUrl] = useState<string>('');
  const [matchOddsTopic, setMatchOddsTopic] = useState<string>('');
  const [error, setError] = useState(null);
  const [eventCounts, setEventCounts] = useState({
    live: 0,
    cricket: 0,
    tennis: 0,
    football: 0,
    baseball: 0,
    basketball: 0,
    greyhound: 0,
    horseracing: 0,
  });

  const Images = HomeView.EVENT_PAGE_IMAGES;

  const tableFields = [
    {
      key: 'schedle',
      Label: langData?.['schedule'],
      className: 'schedule-cell schedule-cell-header',
      align: 'left',
    },
    {
      key: 'teams',
      Label: langData?.['teams'],
      className: 'teams-cell',
      align: 'left',
    },
    {
      key: 'homeTeamOdds',
      Label: '1',
      className: 'odds-cell-head',
      align: 'center',
      colSpan: 2,
    },
    {
      key: 'drawOdds',
      Label: 'X',
      className: 'odds-cell-head',
      align: 'center',
      colSpan: 2,
    },
    {
      key: 'awayTeamOdds',
      Label: '2',
      className: 'odds-cell-head',
      align: 'center',
      colSpan: 2,
    },
    {
      key: 'more',
      Label: '',
      className: 'all-markets-link-cell',
      align: 'center',
    },
  ];

  const updateMatchOddsTopic = (
    currentTopic: string,
    currentBaseUrl: string
  ) => {
    if (
      matchOddsTopic !== currentTopic ||
      matchOddsBaseUrl !== currentBaseUrl
    ) {
      disconnectToWS();
      setMatchOddsTopic(currentTopic);
      setMatchOddsBaseUrl(currentBaseUrl);
    }
  };

  const getOdds = (eventData: EventDTO, teamType: string) => {
    const team =
      teamType === 'home'
        ? eventData.homeTeam
        : teamType === 'away'
        ? eventData.awayTeam
        : teamType;

    for (let runner of eventData.matchOdds.runners) {
      if (
        runner.runnerName.toLowerCase() === team.toLowerCase() ||
        runner.runnerName.toLowerCase().includes(team.toLowerCase())
      ) {
        return [
          {
            type: 'back-odd',
            price: runner?.backPrices[0]?.price,
            size: runner.backPrices[0]?.size,
            outcomeId: runner?.runnerId,
            outcomeName: runner.runnerName,
          },
          {
            type: 'lay-odd',
            price: runner?.layPrices[0]?.price,
            size: runner?.layPrices[0]?.size,
            outcomeId: runner.runnerId,
            outcomeName: runner.runnerName,
          },
        ];
      }
    }
    return null;
  };

  useEffect(() => {
    let liveEventsCount = 0;

    if (inplayEvents?.length > 0) {
      let counts = inplayEvents.reduce(
        (acc, { sportName, events }) => {
          if (!sportName) {
            return acc;
          }

          const key = sportName.toLowerCase();

          // ✅ Corrected condition (Exclude basketball & baseball)
          if (key !== 'basketball' && key !== 'baseball') {
            liveEventsCount += events.length;
          }

          // ✅ Accumulate event counts instead of overwriting
          if (key in acc) {
            acc[key] += events.length;
          }

          acc['live'] += events.length; // ✅ Correctly add to live count

          return acc;
        },
        {
          live: 0,
          cricket: 0,
          tennis: 0,
          football: 0,
          baseball: 0,
          basketball: 0,
          greyhound: 0,
          horseracing: 0,
        }
      );

      setEventCounts(counts);
    }
  }, [inplayEvents]);

  const handleEventChange = (iEvent: InplayEventsObj, event: EventDTO) => {
    const competitionSlug = event.competitionName
      ? event.competitionName
          .toLocaleLowerCase()
          .replace(/[^a-z0-9]/g, ' ')
          .replace(/ +/g, ' ')
          .trim()
          .split(' ')
          .join('-')
      : 'league';
    setEventType({
      id: iEvent.sportId,
      name: iEvent.sportName,
      slug: iEvent.sportSlug,
    });
    setCompetition({
      id: event.competitionId,
      name: event.competitionName,
      slug: competitionSlug,
    });
    setExchEvent({
      id: event.eventId,
      name: event.eventName,
      slug: event.eventSlug,
    });
    history.push(
      `/exchange_sports/${iEvent.sportSlug}/${competitionSlug}/${
        event.eventSlug
      }/${btoa(`${event.sportId}:${event.competitionId}:${event.eventId}`)}`
    );
  };

  const handleMultiMarket = (
    competitionId,
    eventId,
    marketId,
    providerName,
    sportId,
    isAdd = true
  ) => {
    if (loggedIn) {
      if (isAdd) {
        addToMultiMarket(
          competitionId,
          eventId,
          marketId,
          providerName,
          sportId
        );
        marketId &&
          setMultiMarketData((prevState) => {
            return [
              ...prevState,
              {
                competitionId,
                eventId,
                marketId,
                providerName,
                sportId,
              },
            ];
          });
      } else {
        removeToMultiMarket(eventId, marketId);
        marketId &&
          setMultiMarketData((prevState) => {
            let data = [...prevState];
            const index = data?.findIndex(
              (itm) => itm.eventId === eventId && itm.marketId === marketId
            );
            index > -1 && data.splice(index, 1);
            return [...data];
          });
      }
    } else {
      history.push('/login');
    }
  };

  useEffect(() => {
    if (loggedIn && inplayEvents.length > 0 && topicUrls?.matchOddsTopic) {
      for (let iEvent of inplayEvents) {
        const subs = [...wsChannels];
        updateMatchOddsTopic(
          topicUrls?.matchOddsTopic,
          topicUrls?.matchOddsBaseUrl
        );
        for (let sEvent of iEvent.events) {
          if (!subs.includes(sEvent.eventId)) {
            subs.push(sEvent.eventId);
            subscribeWsForEventOdds(
              topicUrls?.matchOddsTopic,
              sEvent.sportId,
              sEvent.competitionId,
              sEvent.eventId,
              sEvent.matchOdds?.marketId
            );
          }
        }
        setWsChannels(subs);
      }
    }
  }, [betFairWSConnected, inplayEvents, loggedIn]);

  const getCompetitionSlug = (competitionName: string) => {
    return competitionName
      .toLocaleLowerCase()
      .replace(/[^a-z0-9]/g, ' ')
      .replace(/ +/g, ' ')
      .trim()
      .split(' ')
      .join('-');
  };

  useEffect(() => {
    fetchBannerData();
  }, []);

  const fetchBannerData = async () => {
    let webdata = [];
    let mobiledata = [];
    let defaultdata = [];
    let defaultMobData = [];
    try {
      const response: AuthResponse = await SVLS_API.get(
        `/account/v2/books/${BRAND_DOMAIN}/banners`,
        {
          headers: {
            'Content-Type': 'application/json',
          },
          params: {
            status: 'active',
            type: '*',
            category: 'inplaybanner',
          },
        }
      );
      let data = response?.data?.banners;
      if (data?.length > 0) {
        data.map((item) => {
          if (item.deviceType === 'desktop') {
            webdata.push(item);
          }
          if (item.deviceType === 'mobile') {
            mobiledata.push(item);
          }
        });
        setApiWebBanners(webdata);
        setApiMobBanners(mobiledata);
      }
      if (webdata.length == 0) {
        defaultdata.push(Images['inplay']);
        setApiWebBanners(defaultdata);
      }
      if (mobiledata.length === 0) {
        defaultMobData.push(Images['inplay']);
        setApiMobBanners(defaultMobData);
      }
    } catch (err) {
      if (webdata.length == 0) {
        defaultdata.push(Images['inplay']);
        setApiWebBanners(defaultdata);
      }
      if (mobiledata.length === 0) {
        defaultMobData.push(Images['inplay']);
        setApiMobBanners(defaultMobData);
      }
      console.log(err);
      //setShowError(true);
      if (err.response && err.response.status === 400) {
        //setErrorText(err.response.data.message);
      } else {
        //setErrorText('Something went wrong');
      }
    }
  };

  const navigateToLink = (data) => {
    if (
      data?.redirectionUrl == '/exchange_sports/inplay' ||
      data?.redirectionUrl == '/casino' ||
      data?.redirectionUrl == '/exchange_sports/cricket' ||
      data?.redirectionUrl == '/exchange_sports/tennis' ||
      data?.redirectionUrl == '/exchange_sports/football'
    ) {
      history.push(data?.redirectionUrl);
    } else if (data?.redirectionUrl == 'nourl') {
    } else if (data.url) {
      history.push(data.url);
    } else {
      let url = data?.redirectionUrl;
      window.open(url, '_blank');
    }
  };

  return (
    <div className="inplay-view-mz">
      {/* <div className="live-count-events">
        <ul className="in-play-top">
          <li className="w-10">
            <a href={'/exchange_sports/inplay'}>
              <span className="in-play-badge red-dot">{eventCounts.live}</span>
              <span className="sports-icon watchlive">
                <Inplay className="livecounticon" />
              </span>
              <span className="inplay-place">{langData?.['live']}</span>
            </a>
          </li>
          <li className="w-10">
            <a href={'/exchange_sports/cricket'}>
              <span className="in-play-badge red-dot">
                {eventCounts.cricket}
              </span>
              <span className="sports-icon watchlive">
                <Cricket className="livecounticon" />
              </span>
              <span className="inplay-place">{langData?.['cricket']}</span>
            </a>
          </li>
          <li className="w-10">
            <a href={'/exchange_sports/football'}>
              <span className="in-play-badge red-dot">
                {eventCounts.football}
              </span>
              <span className="sports-icon watchlive">
                <Football className="livecounticon" />
              </span>
              <span className="inplay-place">{langData?.['football']}</span>
            </a>
          </li>
          <li className="w-10">
            <a href={'/exchange_sports/tennis'}>
              <span className="in-play-badge red-dot">
                {eventCounts.tennis}
              </span>
              <span className="sports-icon watchlive">
                <Tennis className="livecounticon" />
              </span>
              <span className="inplay-place">{langData?.['tennis']}</span>
            </a>
          </li>
          <li className="w-10">
            <a href={'/exchange_sports/basketball'}>
              <span className="in-play-badge red-dot">
                {eventCounts.basketball}
              </span>
              <span className="sports-icon watchlive">
                <Basketball className="livecounticon" />
              </span>
              <span className="inplay-place">{langData?.['basketball']}</span>
            </a>
          </li>
          <li className="w-10">
            <a href={'/exchange_sports/baseball'}>
              <span className="in-play-badge red-dot">
                {eventCounts.baseball}
              </span>
              <span className="sports-icon watchlive">
                <Baseball className="livecounticon" />
              </span>
              <span className="inplay-place">{langData?.['baseball']}</span>
            </a>
          </li>
          <li className="w-10">
            <a href={'/exchange_sports/greyhound'}>
              <span className="in-play-badge red-dot">
                {eventCounts.greyhound}
              </span>
              <span className="sports-icon watchlive">
                <GreyHound className="livecounticon" />
              </span>
              <span className="inplay-place">{langData?.['greyhound']}</span>
            </a>
          </li>
          <li className="w-10">
            <a href={'/exchange_sports/horseracing'}>
              <span className="in-play-badge red-dot">
                {eventCounts.horseracing}
              </span>
              <span className="sports-icon watchlive">
                <Horseracing className="livecounticon" />
              </span>
              <span className="inplay-place">{langData?.['horse_race']}</span>
            </a>
          </li>
        </ul>
      </div> */}

      <div className="events-table-ctn">
        {/* <div className="mob-view">
      {loggedIn ? (
        <Autocomplete
          freeSolo
          id="free-solo-2-demo"
          className="search-events-autocomplete"
          // value={eventName}
          disableClearable
          options={eventsData}
          getOptionLabel={(option) => option.eventName}
          inputValue={eventName}
          onInputChange={(event, newInputValue) => {
            setEventName(newInputValue);
          }}
          onChange={(event, newEvent) => {
            history.push(`/exchange_sports/${getCompetitionSlug(newEvent?.sportName)
              }/${getCompetitionSlug(newEvent?.competitionName)}/${getCompetitionSlug(newEvent?.eventName)
              }/${btoa(
                `${newEvent?.sportId}:${newEvent?.competitionId}:${newEvent?.eventId}`
              )}`);
          }}
          renderInput={(params) => (
            <>
              <TextField
                {...params}
                label="Search"
                margin="normal"
                variant="outlined"
                className="search-games-text"
                InputProps={{ ...params.InputProps, type: 'search' }}
              />
              <div className='search-icon'
                onClick={() => toast.error(
                  <div>
                    <ErrorIcon /> {'Please select an event from dropdown'}
                  </div>,
                  {
                    position: 'top-center',
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  }
                )}>
                <SearchIcon />
              </div>
            </>
          )}
          renderOption={(props, option) => {
            return (
              <span {...props} style={{ color: "white" }}>
                {props.eventName}
              </span>
            );
          }}
        />
      ) : null}
    </div> */}
        {/* <Carousel
      className="mob-banners"
      autoPlay={true}
      infiniteLoop={true}
      interval={5000}
      showThumbs={false}
      showStatus={false}
    >
      {apiMobBanners.map((banner) => (
        <div className={'banner-container inplay-bg mt-14'}>
          <img
            className="banner-image"
            src={banner?.publicUrl}
            key={'inplay-image'}
            alt={'banner'}
            title={banner?.title}
            onClick={() => {
              isValidLink(banner, history);
            }}
          />
        </div>
      ))}
    </Carousel> */}
        {/* <Carousel
          className="web-banners"
          autoPlay={true}
          infiniteLoop={true}
          interval={5000}
          showThumbs={false}
          showStatus={false}
        >
          {apiWebBanners.map((banner) => (
            <div className={'banner-container inplay-bg mt-14'}>
              <img
                className="banner-image"
                src={banner?.publicUrl}
                key={'inplay-image'}
                alt={'banner'}
                title={banner?.title}
                onClick={() => {
                  isValidLink(banner, history);
                }}
              />
            </div>
          ))}
        </Carousel> */}
        {/* <div
      className={'banner-container inplay-bg mt-14'}
      // className={loggedIn ? "banner-container inplay-bg" : "banner-container inplay-bg mt-14"}
    >
      <img
        className="banner-image"
        src={Images['inplay']?.image}
        key={'inplay-image'}
        alt={'banner'}
        title={'In Play'}
      />
    </div> */}

        {inplayEvents.length > 0 &&
        inplayEvents
          // .filter((event) => Number(event?.sportId))
          .filter(
            (event) =>
              event.events.filter((ev) => ev.status === 'IN_PLAY').length > 0
          ).length > 0 ? (
          inplayEvents.map((iEvent, idx) => (
            <>
              {allowedConfig !==
              // & Number(iEvent.sportId)
              0 ? (
                <Accordion
                  className="eventType-accordion"
                  defaultExpanded={true}
                  key={idx}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon className="expand-icon" />}
                    aria-controls="panel1a-content"
                    className="eventType-header"
                  >
                    <IonImg
                      className="sport-inplay-icon"
                      src={SportIconMapInplay[iEvent.sportId]}
                    />
                    <div className="accordian-sport-name">
                      {langData?.[`${getSportLangKeyByName(iEvent.sportName)}`]}
                    </div>
                    {/* <div className="accordian-headers web-view">
                  <div className="accordian-table-headers">1</div>
                  <div className="accordian-table-headers">X</div>
                  <div className="accordian-table-headers">2</div>
                </div> */}
                  </AccordionSummary>

                  <AccordionDetails className="inplay-events-tbl-container">
                    <div className="events-table-content table-ctn">
                      <TableContainer component={Paper}>
                        <Table className="events-table inplay-table">
                          <TableHead className="web-view">
                            <TableRow>
                              {tableFields.map((tF, index) => (
                                <TableCell
                                  key={tF.key + index}
                                  align={
                                    tF.align === 'left' ? 'left' : 'center'
                                  }
                                  colSpan={tF.colSpan ? tF.colSpan : 1}
                                  className={tF.className}
                                >
                                  {tF.Label}
                                </TableCell>
                              ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {iEvent?.events
                              .filter((s) => s.status === 'IN_PLAY')
                              .map((sEvent, idx) => (
                                <TableRow
                                  onClick={() =>
                                    handleEventChange(iEvent, sEvent)
                                  }
                                >
                                  <TableCell className="schedule-cell">
                                    {/* {formatDate(sEvent?.openDate)} */}
                                    <div>
                                      {moment(sEvent?.openDate).format(
                                        'DD MMM'
                                      )}
                                    </div>
                                    <div>
                                      {moment(sEvent?.openDate).format(
                                        'hh:mm A'
                                      )}
                                    </div>
                                  </TableCell>
                                  <TableCell className="teams-cell">
                                    <div
                                      className="all-markets-nav-link"
                                      key={'all-markets-link'}
                                      onClick={() =>
                                        handleEventChange(iEvent, sEvent)
                                      }
                                    >
                                      {sEvent?.homeTeam !== '' &&
                                      sEvent?.awayTeam !== '' ? (
                                        <>
                                          <div className="web-view team-name-ctn">
                                            <div
                                              style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                              }}
                                              className="temas-col"
                                            >
                                              {sEvent.status === 'IN_PLAY' ? (
                                                <div className=" green-circle"></div>
                                              ) : null}
                                              <div className="teams">
                                                <div className="team-name">
                                                  {sEvent.homeTeam}
                                                  {sEvent.status ===
                                                  'IN_PLAY' ? (
                                                    <img
                                                      className="live-img"
                                                      src={
                                                        liveImagesMap[
                                                          sEvent.sportId
                                                        ]
                                                      }
                                                      alt="live"
                                                    />
                                                  ) : null}
                                                </div>
                                                <div className="team-name">
                                                  {sEvent.awayTeam}
                                                </div>
                                              </div>
                                            </div>
                                            <div className="enabled-markets">
                                              {sEvent?.enablePremium && (
                                                <div className="enabled-market-ctn premium-btn">
                                                  <span className="enabled-market-btn">
                                                    P
                                                  </span>
                                                </div>
                                              )}
                                              {sEvent?.enableMatchOdds && (
                                                <div className="enabled-market-ctn mo-btn">
                                                  <span className="enabled-market-btn">
                                                    MO
                                                  </span>
                                                </div>
                                              )}
                                              {sEvent?.enableBookmaker && (
                                                <div className="enabled-market-ctn bookmaker-btn">
                                                  <span className="enabled-market-btn">
                                                    B
                                                  </span>
                                                </div>
                                              )}
                                              {sEvent?.enableFancy && (
                                                <div className="enabled-market-ctn fancy-btn">
                                                  <span className="enabled-market-btn">
                                                    F
                                                  </span>
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                          <div className="mob-view">
                                            <div className="event-details-ctn">
                                              <div className="event-name">
                                                <div>
                                                  <div
                                                    className="e-name"
                                                    style={{
                                                      display: 'flex',
                                                      alignItems: 'center',
                                                    }}
                                                  >
                                                    {sEvent.status ===
                                                    'IN_PLAY' ? (
                                                      <div className=" green-circle"></div>
                                                    ) : null}
                                                    {sEvent.eventName}
                                                  </div>
                                                </div>
                                                {/* <NavLink
                                    className="all-markets-nav-link"
                                    key={'all-markets-link'}
                                    onClick={() => handleEventChange(sEvent)}
                                    to={`/exchange_sports/${selectedEventType.slug
                                      }/${getCompetitionSlug(sEvent.competitionName)}/${sEvent.eventSlug
                                      }/${btoa(
                                        `${sEvent.sportId}:${sEvent.competitionId}:${sEvent.eventId}`
                                      )}`}
                                  >
                                    <ChevronRightIcon />
                                  </NavLink> */}
                                              </div>
                                              <div className="time-odds">
                                                <div className="timings">
                                                  <span className="date-timing">
                                                    {moment(
                                                      sEvent?.openDate
                                                    ).format('DD MMM')}
                                                  </span>
                                                  <span>
                                                    {moment(
                                                      sEvent?.openDate
                                                    ).format('hh:mm A')}
                                                  </span>
                                                  {sEvent.status ===
                                                  'IN_PLAY' ? (
                                                    <img
                                                      className="live-img"
                                                      src={
                                                        liveImagesMap[
                                                          sEvent.sportId
                                                        ]
                                                      }
                                                      alt="live"
                                                    />
                                                  ) : null}
                                                </div>
                                                <div className="enabled-markets">
                                                  {sEvent.status ===
                                                  'IN_PLAY' ? (
                                                    <LiveTvIcon />
                                                  ) : null}
                                                  {sEvent?.enablePremium && (
                                                    <div className="enabled-market-ctn premium-btn">
                                                      <span className="enabled-market-btn">
                                                        P
                                                      </span>
                                                    </div>
                                                  )}
                                                  {sEvent?.enableMatchOdds && (
                                                    <div className="enabled-market-ctn mo-btn">
                                                      <span className="enabled-market-btn">
                                                        MO
                                                      </span>
                                                    </div>
                                                  )}
                                                  {sEvent?.enableBookmaker && (
                                                    <div className="enabled-market-ctn bookmaker-btn">
                                                      <span className="enabled-market-btn">
                                                        B
                                                      </span>
                                                    </div>
                                                  )}
                                                  {sEvent?.enableFancy && (
                                                    <div className="enabled-market-ctn fancy-btn">
                                                      <span className="enabled-market-btn">
                                                        F
                                                      </span>
                                                    </div>
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      ) : (
                                        <div className="team-name">
                                          {sEvent.eventName}
                                        </div>
                                      )}
                                      <div className="mob-odds-row new-odds-row">
                                        {teamTypes.map((teamType, index) => (
                                          <div
                                            className="mob-odds-block"
                                            key={teamType + index}
                                          >
                                            <div className="mob-exchange-btn-odd-row">
                                              {sEvent.matchOdds ? (
                                                getOdds(sEvent, teamType) ? (
                                                  <>
                                                    {getOdds(
                                                      sEvent,
                                                      teamType
                                                    ).map((odd) => (
                                                      <ExchMobOddView
                                                        mainValue={odd.price}
                                                        disable={sEvent.matchOdds.status
                                                          .toLowerCase()
                                                          .includes(
                                                            'suspended'
                                                          )}
                                                        oddType={
                                                          odd.type ===
                                                          'back-odd'
                                                            ? 'back-odd'
                                                            : 'lay-odd'
                                                        }
                                                      />
                                                    ))}
                                                  </>
                                                ) : (
                                                  <>
                                                    <ExchMobOddView
                                                      mainValue={null}
                                                      oddType="back-odd"
                                                      disable={true}
                                                    />
                                                    <ExchMobOddView
                                                      mainValue={null}
                                                      oddType="lay-odd"
                                                      disable={true}
                                                    />
                                                  </>
                                                )
                                              ) : (
                                                <>
                                                  <ExchMobOddView
                                                    mainValue={null}
                                                    oddType="back-odd"
                                                    disable={true}
                                                  />
                                                  <ExchMobOddView
                                                    mainValue={null}
                                                    oddType="lay-odd"
                                                    disable={true}
                                                  />
                                                </>
                                              )}
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  </TableCell>
                                  {/* <TableCell className="score-cell" align="center">
                              <div className="score">0</div>
                              <div className="score">0</div>
                            </TableCell> */}
                                  {teamTypes.map((teamType, index) => (
                                    <TableCell
                                      className="odds-cell"
                                      align="center"
                                      colSpan={2}
                                      key={teamType + index}
                                    >
                                      {sEvent?.matchOdds ? (
                                        getOdds(sEvent, teamType) ? (
                                          <div className="odds-block">
                                            {getOdds(sEvent, teamType).map(
                                              (odd) => (
                                                <ExchOddBtn
                                                  mainValue={odd.price}
                                                  subValue={odd.size}
                                                  oddType={
                                                    odd.type === 'back-odd'
                                                      ? 'back-odd'
                                                      : 'lay-odd'
                                                  }
                                                  disable={sEvent.matchOdds.status
                                                    .toLowerCase()
                                                    .includes('suspended')}
                                                  valueType="matchOdds"
                                                  showSubValueinKformat={true}
                                                  onClick={() => null}
                                                />
                                              )
                                            )}
                                          </div>
                                        ) : (
                                          <EmptyOddsBlock />
                                        )
                                      ) : (
                                        <EmptyOddsBlock />
                                      )}
                                    </TableCell>
                                  ))}
                                  <TableCell className="multi-markets-pin-cell web-view">
                                    {sEvent?.enableMatchOdds ? (
                                      <>
                                        {!checkIncludeMultiMarket(
                                          multiMarketData,
                                          sEvent.matchOdds?.marketId,
                                          sEvent?.eventId
                                        ) ? (
                                          <Tooltip
                                            title={
                                              langData?.[
                                                'add_to_multi_markets_txt'
                                              ]
                                            }
                                            placement="left-start"
                                          >
                                            <img
                                              src={multipin}
                                              alt="multipin"
                                              className="multi-add-icon"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                multiMarketData?.length < 10 &&
                                                  handleMultiMarket(
                                                    sEvent?.competitionId,
                                                    sEvent?.eventId,
                                                    sEvent.matchOdds?.marketId,
                                                    sEvent?.providerName,
                                                    sEvent?.sportId,
                                                    true
                                                  );
                                              }}
                                            />
                                          </Tooltip>
                                        ) : (
                                          <Tooltip
                                            title={
                                              langData?.[
                                                'remove_from_multi_markets_txt'
                                              ]
                                            }
                                            placement="left-start"
                                          >
                                            <img
                                              src={removemultipin}
                                              alt="multipin"
                                              className="multi-remove-icon"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                handleMultiMarket(
                                                  sEvent?.competitionId,
                                                  sEvent?.eventId,
                                                  sEvent.matchOdds?.marketId,
                                                  sEvent?.providerName,
                                                  sEvent?.sportId,
                                                  false
                                                );
                                              }}
                                            />
                                          </Tooltip>
                                        )}{' '}
                                      </>
                                    ) : null}
                                  </TableCell>
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  </AccordionDetails>
                </Accordion>
              ) : null}
            </>
          ))
        ) : !fetchingEvents ? (
          <div className="events-table-msg-text">
            {langData?.['no_inplay_events_txt']}
          </div>
        ) : null}

        {/* <Accordion
        className="bs-accordion"
        expanded={openBetslip}
        onChange={(_, expanded) => setOpenBetslip(expanded)}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon className="expand-icon" />}
          aria-controls="panel1a-content"
          className="bs-header"
        >
          Bet Slip ({bets.length})
        </AccordionSummary>
        <AccordionDetails className="bs-body">
          {bets.length > 0 ? <ExchBetslip /> : null}
        </AccordionDetails>
      </Accordion> */}
      </div>
    </div>
  );
};

export function EmptyOddsBlock() {
  return (
    <React.Fragment>
      <div className="odds-block">
        <div className="odds-cell-common back-odd-cell disabled">
          <ExchOddBtn mainValue={null} oddType="back-odd" />
        </div>

        <div className="odds-cell-common lay-odd-cell disabled">
          <ExchOddBtn mainValue={null} oddType="lay-odd" />
        </div>
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = (state: RootState) => {
  return {
    // bets: state.exchBetslip.bets,
    allowedConfig: state.common.allowedConfig,
    loggedIn: state.auth.loggedIn,
    fetchingEvents: state.exchangeSports.fetchingEvents,
    topicUrls: state?.exchangeSports?.topicUrls,
    betFairWSConnected: state.exchangeSports.betFairWSConnected,
    langData:state.common.langData
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    setEventType: (eType: SelectedObj) => dispatch(setEventType(eType)),
    setCompetition: (competition: SelectedObj) =>
      dispatch(setCompetition(competition)),
    setExchEvent: (event: SelectedObj) => dispatch(setExchEvent(event)),
    fetchCompetitions: (eventTypeId: string) =>
      dispatch(fetchCompetitions(eventTypeId)),
    fetchEventsByCompetition: (etId: string, cId: string) =>
      dispatch(fetchEventsByCompetition(etId, cId, [])),
    // addExchangeBet: (data: BsData) => dispatch(addExchangeBet(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InplayEventsTable);
